module.exports = __webpack_public_path__ + "img/take-away1.3237c2f2.png";